'use strict';

/* Стили */
import '../css/site.scss';

/* Скрипты */
import '../plugins/fslightbox.js';
import sliders from './modules/sliders/sliders.js';
import scroll from './modules/scroll';
import faq from './modules/faq';
import { initAccordion } from './modules/accordion/init-accordion.js';
import { initModal } from './modules/modal/init-modal.js';
import renderParticipationModal from './modules/modal/render-participation-modal.js';
import renderTeachersModal from './modules/modal/render-teachers-modal.js';
import initShowMoreButton from './modules/init-show-more-button.js';
import advCaceProgram from './modules/advCaceProgram.js';
import setTeachersClass from './modules/set-teachers-class.js';
import initFilters from './modules/init-filters.js';
import burger from './modules/burger.js';
import metrics from './modules/metrics.js';
import bannerBack from './modules/bannerBack.js';
import calculator from './modules/calculator.js';
import UtmTags from './modules/UtmTags.js';
import collapse from './modules/collapse.js';
import initForm from './modules/form/init-form.js';
import renderStoriesModal from './modules/modal/render-stories-modal.js';
import initTooltips from './modules/init-tooltips.js';
import catalog from './modules/catalog.js';
import renderStepsModal from './modules/modal/render-steps-modal.js';
import initChangeDate from './modules/date/index.js';
import initVideoVolumeButton from './modules/init-video-volume-button.js';
import initTabs from './modules/init-tabs.js';
import initResolutionLink from './modules/init-resolution-link.js';
import geography from './modules/geography.js';
import initWidjet from './modules/init-widget.js';
import initAppearingModal from './modules/modal/init-appearing-modal.js';
import initQuizVideo from './modules/init-quiz-video.js';

import 'lazysizes';
import '../lib/ls.video-vk-rutube-embed';
import initMoreButton from './modules/init-more-button.js';

document.addEventListener('DOMContentLoaded', () => {
  initModal();
  initAccordion();
  initWidjet();
  // FLOW-10948
  // UtmTags();
  metrics();
  scroll();
  renderParticipationModal();
  renderTeachersModal();
  sliders();
  faq();
  initShowMoreButton('.program', 4);
  initShowMoreButton('.reviewsPage-cards', 5);
  initShowMoreButton('.jobSeeker_catalog', 4);
  initShowMoreButton('.moms_catalog_dpo', 8);
  initShowMoreButton('.moms_catalog_po', 6);
  catalog();
  initAppearingModal();
  initTooltips();
  initForm();
  advCaceProgram();
  setTeachersClass();
  initFilters();
  burger();
  bannerBack();
  calculator();
  collapse();
  renderStoriesModal();
  initTabs();
  renderStepsModal();
  initChangeDate();
  initVideoVolumeButton();
  initResolutionLink();
  geography();
  initQuizVideo();
  initMoreButton();
});
